import React from 'react';

import { AppSumoBillingTable } from '../../components';

import 'react-toggle/style.css';

const AppSumoActiveScreen = () => {
  return (
    <div className="billing__plan-page">
      <AppSumoBillingTable />
    </div>
  );
};

export default AppSumoActiveScreen;
